export const userFacingNameString = (
  documentName: string,
  ownerName?: string
) => {
  switch (documentName) {
    case "certificate_of_incorporation":
      return "Certificate of Incorporation";
    case "ein_confirmation":
      return "EIN Confirmation Document (IRS form 147c or IRS form CP-575)";
    case "power_of_attorney":
      return "Power of Attorney";
    case "id_document":
      return `ID Document (passport or drivers license)${
        ownerName ? ` for ${ownerName}` : ""
      }`;
    case "passport":
      return `Passport${ownerName ? ` for ${ownerName}` : ""}`;
    case "address_verification":
      return `Address Verification for ${
        ownerName || "Officer"
      } (utility bill, bank statement, lease agreement or current pay stub)`;
    case "ssn_card":
      return `SSN Card${ownerName ? ` for ${ownerName}` : ""}`;
  }
};
